import React, { ReactNode } from 'react'

const OwnerCurrentActionFooterContainer = ({
  children,
}: {
  children: ReactNode
}) => {
  return <div className='flex w-full flex-col gap-3 pt-5'>{children}</div>
}

export default OwnerCurrentActionFooterContainer
